import React, { useEffect, useState } from 'react'
import { Page, View, Document as Doc, StyleSheet, PDFViewer } from '@react-pdf/renderer'
import { ClienteType } from '../../../Parametro/Types/ClienteType'
import TableHeader from './Table/header'
import TableRow from './Table/row'
import TableBanner from './Table/banner'

const ClientePdf: React.FC = () => {

    const [cliente, setCliente] = useState<ClienteType[] | null>(null)

    const styles = StyleSheet.create({
        page: {
            flexDirection: 'row',
            backgroundColor: '#E4E4E4'
        },
        section: {
            margin: 10,
            padding: 10,
            flexGrow: 1
        }
    })

    useEffect(() => {
        (async() => { setCliente(JSON.parse(localStorage.getItem('Pessoa')!)) })()
    }, [])

    return(

        <>
            {!!cliente && (
                <PDFViewer style={{ width: '100vw', height: '100vh' }}>
                    <Doc>
                        <Page size="A4" style={styles.page} break>
                            <View style={styles.section}>
                                <TableBanner />
                                <TableHeader />
                                {cliente.map((item, index) => <TableRow key = {index} {...item} />)}
                            </View>
                        </Page>
                    </Doc>
                </PDFViewer>
            )}
        </>

    )

}

export default ClientePdf